import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DiamondIcon(props: IconProps) {
    return <Icon {...props} iconKey={"diamond"}/>
}
